interface DataApiUtils {
  getData: (
    dataPageName: string,
    params: Record<string, unknown>,
    contextName: string
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ) => Promise<any>;
}

interface PCoreWindow {
  getStore?: () => { getState?: () => unknown };
  getDataApiUtils?: () => DataApiUtils;
  getStoreValue?: (storeName: string, propertyPath: string, contextName: string) => unknown;
}

function getPCore(): PCoreWindow | undefined {
  if (typeof window === 'undefined') return undefined;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (window as any).PCore as PCoreWindow | undefined;
}

type MessagingScope = {
  context: string;
  caseID: string;
};

let messagingScope: MessagingScope | undefined;
const messagingScopeListeners = new Set<(scope: MessagingScope) => void>();

export function setMessagingScope(context: string, caseID: string) {
  const changed = messagingScope?.context !== context || messagingScope?.caseID !== caseID;
  messagingScope = { context, caseID };
  if (changed) {
    messagingScopeListeners.forEach((listener) => listener(messagingScope as MessagingScope));
  }
}

export function getMessagingScope(): MessagingScope | undefined {
  return messagingScope;
}

export function subscribeMessagingScope(listener: (scope: MessagingScope) => void): () => void {
  messagingScopeListeners.add(listener);
  if (messagingScope) {
    listener(messagingScope);
  }
  return () => {
    messagingScopeListeners.delete(listener);
  };
}

export default getPCore;
